import React                                   from 'react';
import { printConfirmation as defaultOptions } from 'pu-data/SelectOptions';
import SelectComponent                         from './SelectComponent';


const   PrintConfirmation = (props) => {
  const name = 'print_confirmation';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      groupName={props.groupName}
      inputClassName={props.inputClassName}
      label="Send me a Check Plot?"
      name={name}
      onChange={onChange}
      options={props.options}
      required={props.required}
      selected={props.parameters.get(name)} />
  );
};

PrintConfirmation.defaultProps = {
  options: defaultOptions,
};

export default PrintConfirmation;
